
















































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/Auth/AppModule';
import { ProductMigrationModule } from '@/store/Products/ProductMigrationModule';
import ProductMigrationState from '@/components/Products/ProductMigrations/ProductMigrationState.vue';
import ProductMigration from '@/models/Products/ProductMigrations/ProductMigration';
import ProductMigrationStateModel from '@/models/Products/ProductMigrations/ProductMigrationState';
import PageNames from '@/router/PageNames';

@Component({ name: 'ProductMigrationsWidget',  components: { ProductMigrationState } })
export default class extends Vue {

    ProductMigrationStateModel = ProductMigrationStateModel;

    async beforeMount() {
        // Only get one page because we only want to show the most recent product migration
        await ProductMigrationModule.getProductMigrations(1);
    }

    get productMigration() {
        return ProductMigrationModule.productMigrations[0];
    }

    get loading() {
        return ProductMigrationModule.loading;
    }

    async openDocs(url: string) {
        await AppModule.openExternalDocumentationURL(url);
    }

    async navigateToProductMigration(productMigration: ProductMigration) {
        this.$router.push({ name: PageNames.ProductMigration, params: { id: productMigration.id }, query: { tab: "0" } });
    }

}
